module.exports = "/virtual-football-league/img/amblems/left/logos/Cev.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Cev.png
// module id = 2062
// module chunks = 4